import React from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  TextField,
  Button,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginUser, resetPassword } from "../../Redux/Auth/auth.action";

const validationSchema = Yup.object().shape({

  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
    confirmedPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirmed password is required"),
});

const theme = createTheme();

function ResetPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');

  const initialValues = {
    password: "",
    confirmedPassword: "",
  };

  const handleSubmit = (values, { setSubmitting }) => {
    // Handle form submission here
    console.log(values);
    if(values.password===values.confirmedPassword){
      console.log("yes its working....")
    }
    const data={password:values.password,token}
    dispatch(resetPassword({navigate,data}));
    setSubmitting(false);
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form className="space-y-5">
          <div className="space-y-3">
            <div>
              <Field
                as={TextField}
                name="password"
                placeholder="Password"
                type="password"
                variant="outlined"
                fullWidth
              />
              <ErrorMessage
                name="email"
                component="div"
                className="text-red-500"
              />
            </div>
            <div>
              <Field
                as={TextField}
                name="confirmedPassword"
                placeholder="Confirmed Password"
                type="password"
                variant="outlined"
                fullWidth
              />
              <ErrorMessage
                name="confirmedPassword"
                component="div"
                className="text-red-500"
              />
            </div>
          </div>          <Button  sx={{ padding: ".8rem 0rem" }} fullWidth type="submit" variant="contained" color="primary">
            Reset Password
          </Button>
        </Form>
      </Formik>
      
      <div className="flex items-center space-x-4 mt-5 justify-center">
        <button 
          onClick={() => navigate("/login")}
          className="text-blue-400 hover:text-blue-300 underline bg-transparent border-none cursor-pointer transition-colors duration-200 font-medium"
        >
          LOGIN
        </button>
        <span className="text-gray-400">|</span>
        <button 
          onClick={() => navigate("/register")}
          className="text-blue-400 hover:text-blue-300 underline bg-transparent border-none cursor-pointer transition-colors duration-200 font-medium"
        >
          REGISTER
        </button>
      </div></>
  );
}

export default ResetPassword;
